module.exports = __webpack_public_path__ + "img/45.2610886c.jpg";